<template>
  <div
    id="statistic"
    class="statistic-main main__wrapper statistic-main__wrapper"
  >
    <div class="block_container">
      <div class="statistic-main__title-wrapper">
        <h2 class="title-h2 statistic__title">
          {{ $t('sections.statistic') }}
        </h2>
        <div
          class="details-block details-block__wrapper"
          @click="$router.push({ name: 'statistic' })"
        >
          <h5 class="title-h5 details-block__link statistic-main__details-link">
            {{ $t('main.see_more') }}
          </h5>
          <svg-icon
            class="statistic__details-icon details-block__icon"
            name="arrow"
          />
        </div>
      </div>

      <div class="statistic__table-block">
        <StatisticsTable
          :table="tableData"
          :pagination="getPaginationData"
          @tableHandler="tableHandler"
          class="statistic__table-item"
        />
        <div class="statistic__view-item statistic-main__view-item">
          <h5 class="title-h5 statistic-main__view-title">
            {{ $t(`sections.outbound_tourists`) }}
          </h5>
          <div
            class="statistic-main__number-tourists-item statistic__info-block"
          >
            <h4 class="title-h6 statistic__info-title">
              {{ $t('table.number_of_tourists') }}
            </h4>
            <div class="statistic__info-tourists-block">
              <h2 class="title-h3 statistic__info-tourists-number">
                {{ currentTouristsNumber }}
              </h2>
              <div class="statistic__info-tourists-percent">
                {{ currentGrowthPercentage }}
                <svg-icon
                  name="arrow-statistic"
                  class="statistic__info-arrow"
                  :class="[isGrowth ? 'grouwth' : 'decrease']"
                />
              </div>
            </div>
          </div>
          <div class="statistic__widget statistic-main__widget">
            <current-widgets :widgets-data="widgetsData" :isWidget="isWidget" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  savedTourismReports,
  statisticsTableTourism,
} from '@/api/services/landing'
import StatisticsTable from '@/elements/StatisticsTable.vue'
import currentWidgets from '@/components/charts/currentWidgets.vue'
export default {
  components: {
    StatisticsTable,
    currentWidgets,
  },
  data() {
    return {
      tableData: null,
      currentPeriod: null,
      curPage: 1,
      toPage: 15,
      perPage: 15,
      widgetsData: null,
      isWidget: false,
      isWidget: false,
    }
  },

  async created() {
    await this.getSavedTourismReports();
    !!this.currentPeriod && (await this.getStatisticsTable());
    !!this.tableData && (await this.setWidgetsData());
  },

  computed: {
    ...mapGetters(['getTableSortData', 'getWidgetColors']),

    currentTouristsNumber() {
      return !!this.tableData?.total_number_of_tourists
        ? this.tableData?.total_number_of_tourists
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        : 0
    },

    currentGrowthPercentage() {
      return !!this.tableData?.total_growth_percentage
        ? `${Math.floor(+this.tableData?.total_growth_percentage * 100) / 100}%`
        : '-'
    },

    isGrowth() {
      return (
        !!this.tableData?.total_growth_percentage &&
        this.tableData?.total_growth_percentage > 0
      )
    },

    getPaginationData() {
      return {
        from: this.tableData?.from_item,
        to: this.tableData?.to_item,
        total: this.tableData?.total,
        current_page: this.tableData?.current_page,
        last_page: this.tableData?.total,
      }
    },
  },

  methods: {
    async tableHandler(page) {
      if (!!page) {
        this.curPage = page + 1
      } else {
        this.curPage = 1
      }
      await this.getStatisticsTable()
    },

    async getSavedTourismReports() {
      let res
      try {
        res = await savedTourismReports('outbound_tourism')
        if (res.status === 200) {
          if (!!res.data.data.reports[0]) {
            const { year, quarter } = res.data.data.reports[0]
            this.currentPeriod = { year, quarter }
          }
        }
      } catch (e) {
        console.log('>>> getSavedTourismReports error', e.response.data)
      }
    },

    async getStatisticsTable() {
      let res
      let payload = {
        ...this.getTableSortData,
        'page[size]': 7,
        'page[number]': this.curPage,
        quarter: this.currentPeriod.quarter,
        year: this.currentPeriod.year,
        type_of_tourism: 'outbound_tourism',
      }
      try {
        res = await statisticsTableTourism(payload)
        if (res.status === 200) {
          console.log('>>> getStatisticsTable', res.data.data)
          this.tableData = res.data.data.table
        }
      } catch (e) {
        console.log('>>> getStatisticsTable error', e.response.data)
      }
    },

    async setWidgetsData() {
      let data = this.tableData?.total_number_of_tourists_on_continents
      this.isWidget = !data.every((el) => el.number_of_tourists === 0)

      this.widgetsData = [
        {
          id: 'statistic-main-chart',
          type: 'doughnut',
          data: {
            labels: await data.map((el) => el.name),
            datasets: [
              {
                data: await data.map((el) => el.number_of_tourists),
                backgroundColor: this.getWidgetColors.background,
                hoverBackgroundColor: this.getWidgetColors.hover,
              },
            ],
          },
        },
      ]
    },
  },
}
</script>

<style lang="sass" scoped>
.statistic-main__wrapper
  padding-bottom: 5rem
.statistic-main__title-wrapper
  display: flex
  justify-content: space-between
  margin-bottom: 7rem
  align-items: center
.statistic-main__details-link
  color: black
  white-space: nowrap
.statistic-main__view-item
  @include m
    flex-direction: column
    align-items: center
  @include s
.statistic-main__view-title
  margin-bottom: 40px
  @include m
    text-align: center
  @include s
    // margin-right: 0
  @include xxs
    margin-bottom: 20px

.statistic-main__number-tourists-item
  margin-bottom: 30px
  @include m
    width: 40%
    min-width: 500px
  @include xxs
    min-width: 100%
    // width: 100%
.statistic-main__widget
  @include m
    align-self: center
  @include xxs
</style>

